
<div class="card mt-3">
  <div class="card-body">
    <h4>{{ lostPassword ? 'Reset Password' : 'Update Password' }}</h4>
    <form class="row" [formGroup]="passwordForm">
      <div class="col-sm-12" *ngIf="!this.lostPassword">
        <div class="form-group">
          <label for="currentPassword">Current Password</label>
          <input
            class="form-control"
            type="password"
            name="currentPassword"
            id="currentPassword"
            formControlName="currentPassword"
            required
          >
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="reg-pass">New Password</label>
          <input
            class="form-control"
            type="password"
            name="password"
            id="reg-pass"
            formControlName="password"
            required
          >
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label for="reg-pass-confirm">Confirm New Password</label>
          <input
            class="form-control"
            type="password"
            id="reg-pass-confirm" 
            formControlName="confirmPassword"
            required
          >
        </div>
      </div>
      <div class="col-12 text-center text-sm-right mb-2">
        <button
          [disabled]="this.passwordForm.invalid"
          class="btn btn-primary margin-bottom-none w-100"
          (click)="onSubmit()"
        >Save Changes</button>
      </div>
    </form>
  </div>
</div>
